/**
 * Hardcoded document categories for user_files uploads (Edit User / New User).
 * Educator, children, guardian, and other roles each have their own array.
 * Guardian and children are different roles; child enrollment may use separate tables (ChildFile) too.
 */

/** Categories for educator role. */
export const EDUCATOR_CATEGORIES = [
  'Agreement',
  'Car Seat Safety Certificate',
  'Car Service Certificate',
  'Child Safe Training',
  'Compliance History Statement',
  'CPR/EpiPen',
  'Driver License',
  'Excursion Declaration',
  'First Aid',
  'Initial Home Visit',
  'Insurance Certificate',
  'Interview / Section 2 Employee Orientation and Probation',
  'Medical Report',
  'Police Check (up to 6 months old)',
  'Prohibition Notice Declaration',
  'Qualification',
  'Resume',
  'WWCC',
  'Assistant Record',
  'Household Record',
  'Other',
];

/** Categories for children role. Do not change. */
export const CHILDREN_CATEGORIES = [
  'Enrolment Form',
  'Excursion Consent Form',
  'Immunisation History Statement',
  'Medical Condition Management Plan',
  'Statutory Declaration',
  'Additional Need',
  'Court Order',
  'Other',
];

/** Categories for guardian role. Use Other only; can be extended later. */
export const GUARDIAN_CATEGORIES = ['Other'];

/** Categories for coordinator role. Other first; can be extended later. */
export const COORDINATOR_CATEGORIES = ['Other'];

/** Categories for franchisee_admin role. Other first; can be extended later. */
export const FRANCHISEE_ADMIN_CATEGORIES = ['Other'];

/** Categories for franchisor_admin role. Other first; can be extended later. */
export const FRANCHISOR_ADMIN_CATEGORIES = ['Other'];

/** Fallback for any other role (e.g. parent) or missing role. */
export const OTHER_ROLES_CATEGORIES = ['Other'];

/**
 * Categories for document upload dropdown by user role.
 * Each role has its own array; 'Other' is first for remaining roles. Can extend any array later.
 */
export const getDocumentCategoriesByRole = (role) => {
  if (role === 'educator') return EDUCATOR_CATEGORIES;
  if (role === 'child' || role === 'children') return CHILDREN_CATEGORIES;
  if (role === 'guardian') return GUARDIAN_CATEGORIES;
  if (role === 'coordinator') return COORDINATOR_CATEGORIES;
  if (role === 'franchisee_admin') return FRANCHISEE_ADMIN_CATEGORIES;
  if (role === 'franchisor_admin') return FRANCHISOR_ADMIN_CATEGORIES;
  return OTHER_ROLES_CATEGORIES;
};
